import { Redirect, Route, Switch } from 'react-router-dom';
import { Paths } from './components/Routes';
import { Suspense, lazy } from 'react';
import { useIsCopilotEnabled } from './hooks/useIsCopilotEnabled';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AsyncMissingAccess = /*#__PURE__*/lazy(() => import('./pages/MissingAccess'));
const SuspendedMissingAccess = () => /*#__PURE__*/_jsx(Suspense, {
  fallback: null,
  children: /*#__PURE__*/_jsx(AsyncMissingAccess, {})
});
const Authenticate = ({
  children,
  skipRedirect
}) => {
  const isCopilotEnabled = useIsCopilotEnabled();
  if (!isCopilotEnabled) {
    if (skipRedirect) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "WAITING_FOR_REDIRECT"
      });
    }
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: Paths.MISSING_ACCESS,
        exact: true,
        component: SuspendedMissingAccess
      }), /*#__PURE__*/_jsx(Redirect, {
        path: "/",
        to: Paths.MISSING_ACCESS
      })]
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default Authenticate;